import { HelpCircle, BarChart3, Calendar, Info } from 'lucide-react'

import { ENABLE_ARCHIVED_GAMES } from '../../constants/settings'
import { GAME_TITLE } from '../../constants/strings'
import { CLASH_ASSETS } from '../../lib/clashConstants'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsAboutModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsDatePickerModalOpen: (value: boolean) => void
}

export const Header = ({
  setIsInfoModalOpen,
  setIsAboutModalOpen,
  setIsStatsModalOpen,
  setIsDatePickerModalOpen,
}: Props) => {
  return (
    <header className="clash-header">
      <div className="header-left">
        <img
          src={CLASH_ASSETS.clashLogo}
          alt="CLASH"
          className="header-logo"
          onError={(e) => {
            e.currentTarget.style.display = 'none'
          }}
        />
      </div>

      <div className="header-center">
        <img
          src={CLASH_ASSETS.gameIcon}
          alt=""
          className="header-icon"
        />
        <span className="header-title">{GAME_TITLE}</span>
      </div>

      <nav className="header-right">
        <button
          className="header-btn"
          onClick={() => setIsInfoModalOpen(true)}
          aria-label="How to play"
          title="How to play"
        >
          <HelpCircle size={24} strokeWidth={2} />
        </button>
        {ENABLE_ARCHIVED_GAMES && (
          <button
            className="header-btn"
            onClick={() => setIsDatePickerModalOpen(true)}
            aria-label="Calendar"
            title="Calendar"
          >
            <Calendar size={24} strokeWidth={2} />
          </button>
        )}
        <button
          className="header-btn"
          onClick={() => setIsStatsModalOpen(true)}
          aria-label="Statistics"
          title="Statistics"
        >
          <BarChart3 size={24} strokeWidth={2} />
        </button>
        <button
          className="header-btn"
          onClick={() => setIsAboutModalOpen(true)}
          aria-label="About"
          title="About"
        >
          <Info size={24} strokeWidth={2} />
        </button>
      </nav>
    </header>
  )
}
